import * as Factory from 'factory.ts'
import faker from 'faker'

import { LinkedBankAccountStatuses } from '@webapp/platform/banking/entities/enums/LinkedBankAccountStatusEnum'
import { type LinkedBankAccountApiModel } from '../LinkedBankAccountApiModel'

export const LinkedBankAccountApiModelStub =
  Factory.Sync.makeFactory<LinkedBankAccountApiModel>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    bank_name: Factory.each(() => faker.company.companyName()),
    account_name: Factory.each(() => faker.finance.accountName()),
    account_mask: Factory.each(() => faker.finance.account(4)),
    status: LinkedBankAccountStatuses.VERIFIED,
    gl_code: Factory.each(() => faker.random.alphaNumeric(6)),
  })
